export const ROUTES = {
  ADMIN: {
    DASHBOARD: '/dashboard',
    ORGANIZATIONS: '/organizations',
    CONTENT: '/content',
    STRATEGIES: '/strategies',
    LEARNERS: '/learners',
    USER_MANAGEMENT: '/user-management',
    BIP_TEMPLATE: '/bip-template',
    INSIGHTS_ADMIN: '/insight-admin',
    USER_SEARCH: '/user-search',
    BROADCAST_CONFIG: '/broadcast-config',
    FIDELITY_CHECK: '/fidelity-check',
  },
  MANAGE_SETTINGS: {
    CUSTOM_TIME: '/manage-settings/custom-time',
    CUSTOM_QUESTION: '/manage-settings/custom-question',
    QUESTIONNAIRE: '/manage-settings/questionnaire',
    LOGO: '/manage-settings/logo',
    OPTIONS: '/manage-settings/options',
    FIDELITY_CHECK: '/manage-settings/fidelity-check',
    REFERENCE_MATERIALS: '/manage-settings/reference-materials',
    TITLES: '/manage-settings/titles',
    BEHAVIOR_GOALS: '/manage-settings/behavior-goals',
    NOTES: '/manage-settings/notes',
    REPORT_LABELS: '/manage-settings/report-labels',
  },
  DASHBOARD: {
    DASHBOARD: '/dashboard-activity',
    ACTIVITY_DASHBOARD: '/activity-dashboard',
  },
  INSIGHTS: {
    INSIGHTS: '/insights',
  },
  NOTIFICATION: {
    NOTIFICATION: '/notification',
  },
} as const;

export const ADMIN_ROUTES = Object.values(ROUTES.ADMIN).filter(
  route => route !== ROUTES.ADMIN.DASHBOARD
);
export const DASHBOARD_ROUTES = [
  ROUTES.DASHBOARD.DASHBOARD,
  ROUTES.DASHBOARD.ACTIVITY_DASHBOARD,
];
export const HOME_ROUTES = [ROUTES.ADMIN.DASHBOARD];
export const INSIGHTS_ROUTE = [ROUTES.INSIGHTS.INSIGHTS];
export const USER_MANAGEMENT = [ROUTES.ADMIN.USER_MANAGEMENT];
export const BIP_TEMPLATE = [ROUTES.ADMIN.BIP_TEMPLATE];
export const INSIGHTS_ADMIN_ROUTE = [ROUTES.ADMIN.INSIGHTS_ADMIN];
export const STRATEGIES = [ROUTES.ADMIN.STRATEGIES];
export const USER_SEARCH = [ROUTES.ADMIN.USER_SEARCH];
export const NOTIFICATION = [ROUTES.NOTIFICATION.NOTIFICATION];
export const ORGANIZATIONS = [ROUTES.ADMIN.ORGANIZATIONS];
export const MANAGE_SETTINGS_ROUTES = Object.values(ROUTES.MANAGE_SETTINGS);
